import { fetchApi } from '../lib/apiClient';

/**
 * 个人令牌类型
 */
export interface PersonalToken {
  id: string;
  name: string;
  scopes: string[];
  lastUsedAt: string | null;
  expiresAt: string | null;
  createdAt: string;
}

/**
 * 创建令牌响应类型
 */
export interface CreateTokenResponse {
  id: string;
  token: string;
  name: string;
  scopes: string[];
  expiresAt: string | null;
  message: string;
}

/**
 * 个人令牌服务
 * 用于管理用户的个人访问令牌
 */
export const personalTokenService = {
  /**
   * 获取用户的所有个人令牌
   * @returns 用户的所有个人令牌
   */
  async getUserTokens(): Promise<PersonalToken[]> {
    return await fetchApi<PersonalToken[]>('/personal-tokens', {
      method: 'GET',
    });
  },

  /**
   * 创建新的个人访问令牌
   * @param name 令牌名称
   * @param scopes 权限范围
   * @param expiresAt 过期时间，null表示永不过期
   * @returns 创建的令牌信息
   */
  async createToken(
    name: string,
    scopes: string[] = [],
    expiresAt: string | null = null,
  ): Promise<CreateTokenResponse> {
    return await fetchApi<CreateTokenResponse>('/personal-tokens', {
      method: 'POST',
      body: {
        name,
        scopes,
        expiresAt,
      },
    });
  },

  /**
   * 删除个人令牌
   * @param tokenId 令牌ID
   * @returns 是否成功删除
   */
  async deleteToken(tokenId: string): Promise<{ message: string }> {
    return await fetchApi<{ message: string }>(`/personal-tokens/${tokenId}`, {
      method: 'DELETE',
    });
  },
};
